document.addEventListener('DOMContentLoaded', function () {

const movieTemplate = document.querySelector('.single-films');
if(movieTemplate){
  var lightboxVideo = GLightbox({
    selector: '.glightbox3',
    touchNavigation: true,
    loop: true,
    autoplayVideos: false,
    plyr: {
    css: 'https://cdn.plyr.io/3.5.6/plyr.css',
    js: 'https://cdn.plyr.io/3.6.2/plyr.polyfilled.js',
    config: {
      ratio: '16:9',
      muted: false,
      hideControls: true,
      fullscreen: {
        enabled: true,
        fallback: true,
      },
      youtube: {
        noCookie: true,
        rel: 0,
        showinfo: 0,
        iv_load_policy: 3
      }
    }
  }
  });

 
}

});